// extracted by mini-css-extract-plugin
module.exports = {"h4Wrapper":"terms_h4Wrapper__alo9S","paragWrapper":"terms_paragWrapper___IrEa","spanWrapper":"terms_spanWrapper__pyUrn"};